import colors from './colors';
import fonts from './fonts';
const buttons = {
    buttonHeight: '3.125rem',
    borderRadius: 'initial',
    smallButtonHeight: '2.5rem',
    fontWeight: fonts.weights.regular,
    defaultIconMargin: '0 0.25rem',
    fontSize: '1rem',
    fontSizeMobile: '1rem',
    loadingSpinnerSize: '3rem',
    textColor: colors.white,
    primary: {
        backgroundColor: colors.primaryDark,
        hoverFocusBackgroundColor: colors.primaryDark,
        color: colors.white,
    },
    secondary: {
        backgroundColor: colors.grayL30,
        hoverFocusBackgroundColor: colors.grayL20,
        color: colors.grayD40,
    },
    light: {
        backgroundColor: colors.white,
        hoverFocusBackgroundColor: colors.grayL30,
        color: colors.grayD40,
    },
    dark: {
        backgroundColor: colors.grayD40,
        hoverFocusBackgroundColor: colors.black,
        color: colors.white,
    },
};
export default buttons;
//# sourceMappingURL=buttons.js.map